import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
})
export class TermsOfServiceComponent implements OnInit, OnDestroy {
  constructor(@Inject(DOCUMENT) private document: Document) {
    this.document.body.classList.add('dark-theme');
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.document.body.classList.remove('dark-theme');
  }
}
